import $ from 'jquery';
import { $window, breakpoint } from '../variables/variables.js';
import { debounce } from '../functions/functions.js';



$( () => {
	if ( ! $( '.partners' ).length ) {
		return;
	}

	// Партнёры
	( () => {
		const $inner = $( '.partners__inner' );
		const $outer = $inner.parent();
		const HTML   = $inner.html();
		const $style = $( '<style>' );

		$style.appendTo( document.head );

		function setAnimation() {
			$style.text( '' );
			$inner.html( HTML );

			const $units          = $inner.children();
			const SINGLE_DURATION = breakpoint.isPhone ? 3 : 2;

			$inner.css( 'animation-duration', ( $units.length * SINGLE_DURATION ) + 's' )

			if ( $outer.width() < $inner.width() ) {
				$style.text( `@keyframes partners_slidein {
					to {
						transform: translate3d(` + ( -$units.length * $units.outerWidth() ) + `px, 0, 0);
					}
				}` );
				$inner.html( HTML + HTML );
			}
		}
		setAnimation();
		$window.on( 'resizeWidth', debounce( setAnimation ) );
	} )();
} );
